import React, { useEffect, useState } from 'react';
import { Waypoint } from 'react-waypoint';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse } from 'reactstrap';
import MinusIcon from 'mdi-react/MinusIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import { scroller } from 'react-scroll';
import FeatureItem from './FeatureItem';
import { changeFeature, setUnfoldedCategory, updateFocusedCategory } from '../../../model/configuratorSlice';
import useWindowSize from '../../../hooks/useWindowSize';
import FeatureItemMobile from './FeatureItemMobile';
import { CategoryType, FeatureType, MobileWidth } from '../../../model/constants';
import IsNullOrUndefined from '../../../utils/ObjectUtils';
import FeatureItemLocked from './FeatureItemLocked';

const CategoryItem = ({
  category,
  roomId,
  isLastItem,
  order,
}) => {
  const windowsSize = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const currentUnfoldedCategory = useSelector(state => state.configurator.currentUnfoldedCategory);
  const currentUnfoldOffset = useSelector(state => state.configurator.currentUnfoldOffset);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsOpen(currentUnfoldedCategory === (`${roomId.toString() }-${category.id.toString()}`));
  }, [currentUnfoldedCategory]);

  const onCategoryTouched = () => {
    if (isOpen) {
      dispatch(setUnfoldedCategory(''));
    } else {
      const offset = (order + 1) * 37 + (order < 5 ? 2 : -2);
      dispatch(setUnfoldedCategory({ id: `${roomId.toString() }-${category.id.toString()}`, offset }));
      dispatch(updateFocusedCategory({ room: roomId, category: category.id }));
    }
  };

  const unfoldComplete = () => {
    scroller.scrollTo(roomId,
      {
        containerId: 'container-rooms',
        offset: currentUnfoldOffset,
        duration: 600,
        delay: 0,
        smooth: 'easeInOut',
      });
  };

  const onFeatureSelected = (selectedFeatureId) => {
    dispatch(changeFeature({
      room: roomId,
      feature: selectedFeatureId,
      hasFeatureBeenUnselected: category.selected_feature === selectedFeatureId,
      category: category.id,
    }));
  };

  const checkFeatureSelected = (categoryToCheck, featureId) => {
    if (categoryToCheck.type === CategoryType.Improvement) {
      const featureFound = categoryToCheck.selectedFeatures.find(f => f === featureId);
      return featureFound !== undefined;
    } return categoryToCheck.selected_feature === featureId;
  };

  const getFeatureItem = (feature) => {
    if (windowsSize.width < windowsSize.height && windowsSize.width < MobileWidth) {
      return (
        <FeatureItemMobile
          feature={feature}
          categoryId={category.id}
          categoryType={category.look_type}
          isSelected={category.selected_feature === feature.id}
          disabled={category.look_type === FeatureType.Default && category.features.length === 1}
          onFeatureSelected={onFeatureSelected}
        />
      );
    }

    if (!IsNullOrUndefined(feature.availableIf) || !IsNullOrUndefined(feature.incompatibleWith)) {
      return (
        <FeatureItemLocked
          feature={feature}
          categoryId={category.id}
          categoryType={category.look_type}
          isSelected={category.selected_feature === feature.id}
          onFeatureSelected={onFeatureSelected}
        />
      );
    }
      return (
        <FeatureItem
          feature={feature}
          categoryId={category.id}
          categoryType={category.look_type}
          isSelected={category.selected_feature === feature.id}
          disabled={category.look_type === FeatureType.Default && category.features.length === 1}
          onFeatureSelected={onFeatureSelected}
        />
      );
  };

  return (
    <div className={`category-item ${category.look_type === CategoryType.Improvement ? ' improvement' : ''}`}>
      <Waypoint topOffset={200} />
      <button type="button" onClick={onCategoryTouched} className="category-title-button">
        <div className="container-name-plus">
          {/* TODO: Use for debugging <div className="name">{`${category.name } ${category.id}`}</div> */}
          {/* <div className="name">{`${category.name} ${category.id}`}</div> */ }
          <div className="name">{category.name}</div>
          <div className="container-improvement-plus">
            {category.look_type === CategoryType.Improvement ? (
              <div className="improvement-container">
                <span>Mejora</span>
              </div>
            ) : null}
            <div className="container-icon">
              <PlusIcon className={`icon ${!isOpen ? '' : ' hidden'}`} />
              <MinusIcon className={`icon ${isOpen ? '' : ' hidden'}`} />
            </div>
          </div>
        </div>
      </button>

      <div className="divider" />
      <Collapse isOpen={isOpen} onEntered={() => unfoldComplete()}>
        <div className="container-features">
          {category.features.map((feature, index) => getFeatureItem(feature))}
        </div>
      </Collapse>
      {isLastItem
        ? (<Waypoint topOffset={30} />)
        : (<Waypoint topOffset={200} />)}


    </div>
  );
};

CategoryItem.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    cameras: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      roomId: PropTypes.string,
      isPriority: PropTypes.bool,
    })),
    selected_feature: PropTypes.string,
    lockedBy: PropTypes.string,
    look_type: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      thumb: PropTypes.string,
      price: PropTypes.string,
      order: PropTypes.number,
    })),
  }).isRequired,
  roomId: PropTypes.string.isRequired,
  isLastItem: PropTypes.bool.isRequired,
  order: PropTypes.number.isRequired,
};

export default CategoryItem;
